<template>
  <div class="deliveryFee">
    <!-- 条件查询 -->
    <div class="search">
      <el-form :inline="true" :model="searchForm">
        <el-form-item label="规则名称">
          <el-input v-model="searchForm.deliveryRulesName" placeholder="请输入规则名称" />
        </el-form-item>
        <el-form-item label="快递公司">
          <el-select v-model="searchForm.companyName" placeholder="请选择">
            <el-option v-for="item in companyList" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="$refresh(getDeliverysList, true)">查询</el-button>
          <el-button icon="el-icon-refresh" @click="$reset(getDeliverysList, { deliveryRulesName: '' })">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 操作按钮 -->
    <div class="button">
      <el-button icon="el-icon-plus" type="primary" @click="addDelivery">新增规则</el-button>
      <el-button icon="el-icon-plus" type="primary" @click="batchDelete">批量删除</el-button>
    </div>
    <!-- 配送费收费规则列表 -->
    <el-table v-loading="loading" ref="multipleTable" :max-height="tableHeight" :data="deliveryList" style="margin: 12px 0 0 0; width: 100%;" border @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="50" />
      <el-table-column type="index" label="序号" width="50" />
      <el-table-column prop="deliveryRulesName" label="规则名称" min-width="100" />
      <el-table-column prop="companyName" label="快递公司" min-width="80" />
      <el-table-column prop="rules" label="收费标准" min-width="450" />
      <el-table-column prop="createTime" label="创建时间" min-width="160" />
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" type="primary"
            @click="editDelivery(scope.row.deliveryRulesId, 0)">编辑</el-button>
          <el-button icon="el-icon-view" @click="editDelivery(scope.row.deliveryRulesId, 1)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增或编辑弹框 -->
    <el-dialog class="deliveryEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="600px"
      :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
      <el-form :model="editForm" ref="editForm" :rules="editFormRules" :disabled="dialogTitle == '配送费收费规则详情'"
        label-width="80px" inline>
        <el-form-item label="规则名称" prop="deliveryRulesName">
          <el-input v-model="editForm.deliveryRulesName" clearable placeholder="请输入配送规则名称" />
        </el-form-item>
        <el-form-item label="覆盖区域" prop="deliveryRulesItems">
          <TreeSelect v-model="editForm.deliveryRulesItems" :options="provincesList" multiple
            :disabled="dialogTitle == '配送费收费规则详情'" :normalizer="normalizer" placeholder="请选择该规则覆盖的区域"
            noResultsText="没有可匹配值！" />
        </el-form-item>
        <el-form-item label="快递公司" prop="companyName">
          <el-select v-model="editForm.companyName" placeholder="请选择">
            <el-option v-for="item in companyList" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收费规则" prop="type">
          <el-radio-group v-model="editForm.type">
            <el-radio v-for="item in [{ value: '0', label: '固定收费' }, { value: '1', label: '阶梯收费' }]" :key="item.value"
              :label="item.value">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="固定价格" prop="fixedPrice" class="bn" v-if="editForm.type == 0">
          <el-input v-model="editForm.fixedPrice" oninput="value=value.replace(/[^\d.]/g,'')" placeholder="请输入固定价格">
            <template slot="prepend">每单配送费均为</template>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <!-- 阶梯收费 -->
        <div v-if="editForm.type == 1">
          <el-form-item label="计费条件" prop="ladderType">
            <el-radio-group v-model="editForm.ladderType">
              <el-radio v-for="item in [{ value: '0', label: '药品付数' }, { value: '1', label: '药品重量' }]" :key="item.value"
                :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="基础数量" prop="fixedNumber">
            <el-input v-model.number="editForm.fixedNumber" placeholder="请输入基础数量">
              <template slot="append" v-if="editForm.ladderType == '0'">付</template>
              <template slot="append" v-if="editForm.ladderType == '1'">g</template>
            </el-input>
          </el-form-item>
          <el-form-item label="基础价格" prop="fixedPrice">
            <el-input v-model="editForm.fixedPrice" oninput="value=value.replace(/[^\d.]/g,'')" placeholder="请输入基础价格">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="递增数量" prop="beyondNumber">
            <el-input v-model.number="editForm.beyondNumber" placeholder="请输入递增数量">
              <template slot="append" v-if="editForm.ladderType == '0'">付</template>
              <template slot="append" v-if="editForm.ladderType == '1'">g</template>
            </el-input>
          </el-form-item>
          <el-form-item label="递增价格" prop="beyondPrice">
            <el-input v-model="editForm.beyondPrice" oninput="value=value.replace(/[^\d.]/g,'')" placeholder="请输入递增价格">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </div>
        <!-- 包邮规则 -->
        <el-form-item label="包邮规则" prop="freeShippingType">
          <el-radio-group v-model="editForm.freeShippingType">
            <el-radio v-for="item in ['不包邮', '药费', '付数']" :key="item" :label="item" />
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="'包邮' + editForm.freeShippingType" prop="freeShippingNumber"
          v-if="editForm.freeShippingType != '不包邮'">
          <el-input v-model.number="editForm.freeShippingNumber" :placeholder="'请输入包邮' + editForm.freeShippingType">
            <template slot="append"></template>
            <template slot="append" v-if="editForm.freeShippingType == '药费'">元</template>
            <template slot="append"></template>
            <template slot="append" v-if="editForm.freeShippingType == '付数'">付</template>
            <template slot="append"></template>
            <template slot="append" v-if="editForm.freeShippingType == '重量'">g</template>
          </el-input>
        </el-form-item>
      </el-form>
      <!-- 操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button type="success" v-if="dialogTitle == '新增配送费收费规则'" @click="addSave">保存新增</el-button>
        <el-button type="success" v-if="dialogTitle == '编辑配送费收费规则'" @click="editSave">保存修改</el-button>
        <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 分页 -->
    <el-pagination
      @current-change="page => $handleCurrentChange(page, getDeliverysList)"
      :total="total"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>
  import TreeSelect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import { deliveryList, deliveryEdit, deliveryAdd, deliveryInfo, getCompany, deleteDeliveryRules } from "@/api/delivery" // 配送费收费规则请求
  import { provincesList } from "@/api/region" // 获取区域请求
  import { isEmptyArray } from '../../../../utils/validateBase'
  export default {
    name: 'deliveryFee',
    components: { "TreeSelect": TreeSelect },
    data() {
      return {
        loading: true, // 加载中
        searchForm: { deliveryRulesName: null, companyName: null }, // 查询表单
        deliveryList: [], // 配送费收费规则列表
        currentPage: 1, // 当前页
        pageSize: 10, // 显示条数
        total: 0, // 总条数
        dialogTitle: null, // 弹框标题
        dialogVisible: false, // 新增或编辑弹框状态
        editForm: {}, // 新增或编辑表单
        provincesList: [], // 区域数组
        companyList: [],//配送公司列表
        editFormRules: {
          deliveryRulesName: [{ required: true, message: "规则名称不能为空！", trigger: "blur" }],
          deliveryRulesItems: [{ required: true, message: "覆盖区域不能为空！", trigger: "change" }],
          companyName: [{ required: true,message:'快递公司不能为空！', trigger:'change' }],
          type: [{ required: true }],
          fixedPrice: [{ required: true, message: "固定价格不能为空！", trigger: "blur" }],
          ladderType: [{ required: true }],
          fixedNumber: [{ required: true, message: "基础数量不能为空！" }, { type: 'number', message: "数量为整数格式！" }],
          beyondPrice: [{ required: true, message: "递增价格不能为空！", trigger: "blur" }],
          beyondNumber: [{ required: true, message: "递增数量不能为空！" }, { type: 'number', message: "数量为整数格式！" }],
          freeShippingType: [{ required: true, message: "包邮规则不能为空！", trigger: "change" }],
          freeShippingNumber: [{ required: true, message: "包邮数量不能为空！" }, { type: 'number', message: "数量为整数格式！" }]
        }, // 验证规则
        normalizer(obj) { // 键名转换，方法默认是label和children进行树状渲染
          return { id: obj.provincesId, label: obj.provincesName }
        },
        tableHeight: 0, // 表格最大高度
        multipleSelection: []
      }
    },
    created() {
      this.tableHeight = document.documentElement.clientHeight - 330;
      this.getDeliverysList(); // 请求配送费收费规则列表
      this.getProvincesList(); // 请求省级区域列表
      this.getCompanyList()
    },
    methods: {
      /**
       * 批量删除
       */
      batchDelete() {
        if (isEmptyArray(this.multipleSelection)) return this.$message.error('请选择删除内容')
        let deliveryRulesIds = []
        this.multipleSelection.forEach(item => {
          deliveryRulesIds.push(item.deliveryRulesId)
        })
        deleteDeliveryRules(deliveryRulesIds).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功')
            this.getDeliverysList();
          }
        })
      },
      /**
       * 表格选中时触发
       */
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      /**
      * 获取物流公司
      */
      async getCompanyList() {
        let { code, data } = await getCompany();
        if (code == 200) this.companyList = data
      },
      // 请求所有配送费收费规则列表
      async getDeliverysList() {
        let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
        let { total, rows, code } = await deliveryList(params);
        if (code == 200) {
          this.total = total;
          rows.forEach(item => {
            let rules = "", unit = "";
            // 包邮规则
            switch (item.freeShippingType) {
              case '0': item.freeShippingType = '不包邮'; break;
              case '1': item.freeShippingType = '药费'; unit = "元"; break;
              case '2': item.freeShippingType = '付数'; unit = "付"; break;
              case '3': item.freeShippingType = '重量'; unit = "g"; break;
            }
            // 收费标准
            if (item.type == '0') {
              rules = `固定价格，每单配送费均为 ${item.fixedPrice} 元`;
              if (item.freeShippingType != "不包邮") rules += `( 包邮规则：每单满 ${item.freeShippingNumber} ${unit}包邮！)`;
              else rules += `( 包邮规则：不包邮！)`;
            } else {
              let unit1 = item.ladderType == '0' ? "付" : "g";
              rules = `递增价格，每单 ${item.fixedNumber} ${unit1}内，配送费 ${item.fixedPrice} 元，每加 ${item.beyondNumber} ${unit1}加 ${item.beyondPrice} 元 `
              if (item.freeShippingType != "不包邮") rules += `( 包邮规则：每单满 ${item.freeShippingNumber} ${unit}包邮！)`;
              else rules += `( 包邮规则：不包邮！)`;
            }
            item.rules = rules;
          });
          this.deliveryList = rows;
        }
        this.loading = false;
      },
      // 请求所有区域列表列表
      async getProvincesList() {
        let { rows, code } = await provincesList();
        if (code == 200) this.listToTree(rows);
      },
      // 链式结构转树形结构
      listToTree(list) {
        this.provincesList = [];
        // 省份列表
        list.forEach(item => { if (item.type == "0") this.provincesList.push(item) });
        // 城市列表
        list.forEach(item => {
          if (item.type == "1") {
            this.provincesList.forEach(items => {
              if (item.parentId == items.provincesId) items.children.push(item);
            });
          }
        });
        // 区/县列表
        list.forEach(item => {
          if (item.type == "2") {
            this.provincesList.forEach(items => {
              items.children.forEach(itemm => {
                if (item.parentId == itemm.provincesId) itemm.children.push(item);
              });
            })
          }
        });
        // 范围列表
        list.forEach(item => {
          if (item.type == "3") {
            this.provincesList.forEach(items => {
              items.children.forEach(itemm => {
                itemm.children.forEach(itemn => {
                  if (item.parentId == itemn.provincesId) itemn.children.push(item);
                })
              });
            })
          }
        });
      },
      // 新增配送费收费规则
      addDelivery() {
        this.dialogVisible = true;
        this.dialogTitle = "新增配送费收费规则";
        this.editForm = {
          deliveryRulesName: null, deliveryRulesItems: [], companyName: "", type: "0", fixedPrice: null, ladderType: "0",
          fixedNumber: null, beyondNumber: null, beyondPrice: null, freeShippingType: "不包邮", freeShippingNumber: null
        };
      },
      // 保存新增
      addSave() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            deliveryAdd(this.handle()).then(res => {
              let { code } = res;
              if (code == 200) this.$message.success("新增配送费收费规则成功！");

              this.dialogVisible = false;
              this.$refresh(this.getDeliverysList);
              this.$refs['editForm'].resetFields();
            })
          } else return false;
        })
      },
      // 编辑配送费收费规则信息
      async editDelivery(deliveryRulesId, type) {
        let { code, data } = await deliveryInfo(deliveryRulesId);
        if (code == 200) {
          let Items = [];
          data.deliveryRulesItems.forEach(item => {
            Items.push(item.provincesId);
          });
          // 包邮规则
          switch (data.freeShippingType) {
            case '0': data.freeShippingType = '不包邮'; break;
            case '1': data.freeShippingType = '药费'; break;
            case '2': data.freeShippingType = '付数'; break;
            case '3': data.freeShippingType = '重量'; break;
          }
          data.deliveryRulesItems = Items;
          this.dialogTitle = type == 0 ? "编辑配送费收费规则" : "配送费收费规则详情";
          this.dialogVisible = true;
          this.editForm = data;
        }

      },
      // 保存配送费收费规则修改
      editSave() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            deliveryEdit(this.handle()).then(res => {
              let { code } = res;
              if (code == 200) this.$message.success("修改配送费收费规则成功！");

              this.dialogVisible = false;
              this.$refresh(this.getDeliverysList);
              this.$refs['editForm'].resetFields();
            })
          } else return false;
        })
      },
      // 处理参数
      handle() {
        let params = JSON.parse(JSON.stringify(this.editForm));
        switch (params.freeShippingType) {
          case '不包邮': params.freeShippingType = 0; break;
          case '药费': params.freeShippingType = 1; break;
          case '付数': params.freeShippingType = 2; break;
          case '重量': params.freeShippingType = 3; break;
        }
        let provincesList = [], Items = [];
        this.provincesList.forEach(item => {
          provincesList.push(item);
          if (item.children != null) item.children.forEach(items => {
            provincesList.push(items);
            if (items.children != null) items.children.forEach(itemss => {
              provincesList.push(itemss);
              if (itemss.children != null) itemss.children.forEach(itemsss => {
                provincesList.push(itemsss);
              })
            })
          })
        })
        provincesList.forEach(item => {
          params.deliveryRulesItems.forEach(items => {
            if (item.provincesId == items) Items.push(item);
          })
        });
        params.deliveryRulesItems = Items;
        return params;
      }
    }
  }
</script>

<style lang="less" scoped>
  .deliveryFee {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .deliveryEdit {
    .el-form-item {
      width: 560px;
      margin-bottom: 10px;
    }

    /deep/.el-input,
    /deep/.el-form-item__content {
      width: 480px;
    }

    /deep/.el-input-group__append {
      width: 50px;
      padding: 0;
      text-align: center;
    }

    .bn {

      /deep/.el-input-group__prepend,
      /deep/.el-input-group__append {
        background-color: #fff;
        border: none;
        color: #606266;
        font-size: 14px;
        padding: 0 5px;
      }

      /deep/.el-input__inner {
        border: none;
        border-bottom: 1px solid #DCDFE6;
      }
    }

  }
</style>
